import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-c92a022a"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "card-box"
};
const _hoisted_2 = {
  class: "online-card"
};
const _hoisted_3 = {
  class: "left"
};

const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "title"
}, "在线学堂", -1));

const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "online-image"
}, null, -1));

const _hoisted_6 = {
  key: 0,
  class: "menu-list"
};
const _hoisted_7 = {
  class: "left"
};
const _hoisted_8 = ["src"];
const _hoisted_9 = {
  class: "menu-title"
};

const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-chakanquanbu arrow-icon"
}, null, -1));

const _hoisted_11 = {
  key: 1,
  class: "menu-card"
};
const _hoisted_12 = ["src"];
const _hoisted_13 = {
  class: "card-text"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_hoisted_4, _createElementVNode("span", {
    class: "online-link",
    onClick: _cache[0] || (_cache[0] = (...args) => $options.zhsLogin && $options.zhsLogin(...args))
  }, "进入 >")]), _hoisted_5]), $props.zhsRole == 3 || $props.zhsRole == 0 ? (_openBlock(), _createElementBlock("ul", _hoisted_6, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.menuList, item => {
    return _openBlock(), _createElementBlock("li", {
      class: "menu-item",
      key: item.name,
      onClick: _cache[1] || (_cache[1] = (...args) => $options.zhsLogin && $options.zhsLogin(...args))
    }, [_createElementVNode("div", _hoisted_7, [_createElementVNode("img", {
      src: item.icon_url,
      alt: "",
      class: "menu-icon"
    }, null, 8, _hoisted_8), _createElementVNode("span", _hoisted_9, _toDisplayString(item.app_name), 1)]), _hoisted_10]);
  }), 128))])) : (_openBlock(), _createElementBlock("ul", _hoisted_11, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.menuList, item => {
    return _openBlock(), _createElementBlock("li", {
      class: "card-item",
      key: item.name,
      onClick: _cache[2] || (_cache[2] = (...args) => $options.zhsLogin && $options.zhsLogin(...args))
    }, [_createElementVNode("img", {
      src: item.icon_url,
      class: "card-icon",
      alt: ""
    }, null, 8, _hoisted_12), _createElementVNode("span", _hoisted_13, _toDisplayString(item.app_name), 1)]);
  }), 128))]))]);
}